import type { Strings } from './strings.js';

export const tr: Strings = {
  languageName: 'Türkçe',
  welcome: 'Hoş geldiniz',
  chooseReason: 'Size nasıl yardımcı olabiliriz?',
  back: 'Geri',
  cancel: 'İptal',
  next: 'Devam',
  submit: 'Kaydı gönder',
  submitting: 'Gönderiliyor',
  yourDetails: 'Bilgileriniz',
  optional: 'isteğe bağlı',
  required: 'zorunlu alan',
  requiredHint: 'Lütfen işaretli alanları doldurun.',
  fieldRequired: 'Lütfen bu alanı doldurun.',
  fieldInvalid: 'Lütfen bu bilgiyi kontrol edin.',
  pleaseSelect: 'Lütfen seçin',
  search: 'Ara',
  noResults: 'Sonuç yok',
  noOptions: 'Şu anda burada seçilebilecek bir seçenek yok. Lütfen bir görevliye başvurun.',
  stepReason: 'Ziyaret nedeni',
  stepDetails: 'Bilgiler',
  stepDone: 'Tamam',
  thankYou: 'Teşekkür ederiz!',
  submitted: 'Kaydınız iletildi.',
  waitHint: 'Lütfen yerinize oturun. Kısa süre içinde çağrılacaksınız.',
  scanFormHint: 'Formu yanınıza almak için kodu telefonunuzla tarayın.',
  ticketNumber: 'Sıra numaranız',
  queuedTitle: 'Teşekkür ederiz!',
  queuedHint: 'Kaydınız saklandı ve otomatik olarak iletilecek. Lütfen yerinizi alın.',
  errorTitle: 'Maalesef bu işlem gerçekleşmedi',
  errorHint: 'Lütfen tekrar deneyin veya bir görevliye başvurun.',
  tryAgain: 'Tekrar dene',
  startOver: 'Yeniden başla',
  closedTitle: 'Yönetimimiz şu anda kapalı',
  closedHint: 'Yine de kayıt olabilirsiniz - bir sonraki iş gününde size döneceğiz.',
  closedCallUs: 'Telefonla ulaşabilirsiniz',
  continueAnyway: 'Yine de kayıt ol',
  appointmentQuestion: 'Randevunuz var mı?',
  appointmentYes: 'Evet, randevum var',
  appointmentNo: 'Hayır, randevum yok',
  visitingWhom: 'Kimi ziyaret etmek istiyorsunuz?',
  privacyTitle: 'Veri koruma',
  privacyAccept: 'Gizlilik bildirimini okudum.',
  privacyRequired: 'Lütfen gizlilik bildirimini onaylayın.',
  offline: 'Çevrimdışı',
  offlineHint: 'Bağlantı yok - kayıtlar saklanır ve daha sonra iletilir.',
  pendingCount: 'saklanan kayıt',
  idleWarning: 'Girdileriniz birazdan silinecek.',
  pairTitle: 'Tableti bağla',
  pairHint: 'Lütfen yönetimden aldığınız eşleştirme kodunu girin.',
  pairPlaceholder: 'ABCD-1234',
  pairButton: 'Bağlan',
  pairError: 'Kod geçersiz veya süresi dolmuş.',
  pairSuccess: 'Tablet bağlandı',
  loading: 'Yükleniyor',
  notConfigured: 'Ziyaret türü tanımlanmamış',
  notConfiguredHint: 'Lütfen bir görevliye başvurun.',
  adminLink: 'Yönetim',
  pairCodeHint:
    'Kod, yönetim arayüzünde “Konumlar ve Tabletler” bölümünde oluşturulur ve yalnızca sınırlı bir süre geçerlidir.',
  setupTitle: 'Henüz kurulmadı',
  setupText:
    'Bu sistem henüz kurulmadı. Kurulum sihirbazı yöneticiyi, kurumu, konumu ve ilk tableti oluşturur.',
  setupButton: 'Kuruluma başla',
  setupAfter: 'Bunun ardından eşleştirme kodu alanı burada otomatik olarak görünür.',
};
